<script>
import api from '@/command/api'
import DetailFormGroup from '../../../components/DetailFormGroup'
import moment from 'moment'

export default {
  name: 'timedDrawDetail',
  data() {
    return {
      ...api.command.getState(),
      detail: {
        displayLocation: '0',
        dailyNum: null,
        intervalHours: null,
        contentType: '0',
      },
    }
  },
  mounted() {
    const { id } = this.$route.query
    id &&
      api.command.getDetail
        .call(this, {
          url: `/farmPopUpAdvertisement/detail?id=${id}`,
        })
        .then((res) => {})
  },
  methods: {
    getForm1() {
      return {
        title: '基本信息',
        type: 'cardForm',
        data: [
          {
            name: '活动名称（仅后台展示）',
            type: 'input',
            cols: 12,
            key: 'name',
            rules: [
              {
                required: true,
              },
            ],
          },
          {
            name: '活动时间',
            type: 'rangePicker',
            key: 'startTime',
            keys: ['startTime', 'endTime'],
            cols: 12,
            display: true,
            showTime: true,
            rules: [
              {
                required: true,
                message: '请选择活动时间',
                trigger: 'change',
              },
            ],
            props: {
              format: 'YYYY-MM-DD HH:mm:ss',
              mode: 'time',
            },
          },
          {
            name: '适用位置',
            type: 'radioButton',
            key: 'displayLocation',
            cols: 12,
            defaultValue: '0',
            typeData: [
              {
                name: '首页',
                value: '0',
              },
            ],
            rules: [
              {
                required: true,
              },
            ],
          },
          {
            name: '广告频次(次)(按账号设置每日跳出次数)',
            type: 'inputNumber',
            cols: 6,
            gutter: 10,
            key: 'dailyNum',
            rules: [
              {
                required: true,
                type: 'number',
              },
            ],
            props: {
              min: 0,
            },
          },
          {
            name: '时间段间隔（小时）',
            type: 'inputNumber',
            cols: 6,
            gutter: 10,
            key: 'intervalHours',
            rules: [
              {
                required: true,
                type: 'number',
              },
            ],
            props: {
              min: 0,
              precision: 0,
            },
          },
        ],
      }
    },
    getForm2() {
      return {
        type: 'cardForm',
        title: '内容',
        data: [
          {
            name: '类型',
            type: 'radioButton',
            key: 'contentType',
            cols: 12,
            defaultValue: '0',
            typeData: [
              {
                name: '图片',
                value: '0',
              },
              {
                name: '文本',
                value: '1',
              },
            ],
            rules: [
              {
                required: true,
              },
            ],
          },
        ],
      }
    },
    getForm3() {
      return {
        type: 'cardForm',
        title: (
          <div>
            {this.detail.contentType === '0' && <span style="color:#f5222d">*</span>}图片设置（建议尺寸：300*400）像素
          </div>
        ),
        data: [
          {
            type: 'upload',
            maxLength: 1,
            cols: 24,
            key: 'imgUrl',
            rules:
              this.detail.contentType === '0'
                ? [
                    {
                      required: true,
                      message: '请上传图片',
                      type: 'string',
                    },
                  ]
                : [],
          },
        ],
      }
    },
    getForm4() {
      if (this.detail.contentType !== '1') return
      return {
        type: 'cardForm',
        title: '文本',
        data: [
          {
            name: '标题',
            type: 'input',
            cols: 12,
            key: 'title',
            maxLength: 25,
            rules: [
              {
                required: true,
              },
            ],
          },
          {
            name: '内容',
            type: 'textArea',
            key: 'content',
            cols: 24,
            maxLength: 300,
            showCount: true,
            rules: [
              {
                required: true,
              },
            ],
          },
        ],
      }
    },

    getFoot() {
      const left = [
        {
          name: '提交',
          type: 'primary',
          loading: this.loading,
          sumbit: true,
          onClick: (data) => {
            if (!data.startTime || !data.endTime) {
              this.$message.error('请选择活动时间')
              return
            }
            const { startTime, endTime } = data
            if (startTime && endTime) {
              if (!moment(startTime).isBefore(endTime)) {
                this.$message.warning('报名结束时间应在开始时间之后！')
                return
              }
            }
            api.command[data.id ? 'edit' : 'create']
              .call(this, {
                url: `/farmPopUpAdvertisement/${data.id ? 'update' : 'save'}`,
                params: {
                  upDown: '1',
                  ...data,
                  startTime: moment(data.startTime).format('YYYY-MM-DD HH:mm:ss'),
                  endTime: moment(data.endTime).format('YYYY-MM-DD HH:mm:ss'),
                },
                isPost: false,
              })
              .then(() => {
                this.$router.back()
              })
          },
        },
        {
          name: '取消',
          onClick: () => {
            this.$router.back()
          },
        },
      ]

      const right = [
        {
          name: '删除',
          type: 'danger',
          isPop: true,
          popTitle: '确认是否删除吗?',
          ghost: true,
          onClick: () => {
            api.command.del.call(this, {
              url: '/farmPopUpAdvertisement/deleteBatch',
              params: { idList: [this.detail.id] },
              isPost: false,
            })

            setTimeout(() => {
              this.$router.back()
            }, 100)
          },
        },
      ]

      return {
        left,
        right: this.detail.id && right,
      }
    },
  },
  render() {
    return (
      <DetailFormGroup
        foot={this.getFoot()}
        form={this.detail}
        data={[this.getForm1(), this.getForm2(), this.getForm4(), this.getForm3()]}
      />
    )
  },
}
</script>
<style lang="less" scoped>
.entityInformation-detail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
}

/deep/ .ant-table-footer {
  padding-left: 0;
  padding-right: 0;
}

/deep/.ant-table-fixed {
  padding-left: 0px !important;

  td {
    padding-left: 0;
  }
}
</style>
